export default {
  get (uri) {
    return fetch(uri).then(response => response.json())
  },
}
